export const meta = {
  title: '关于 PDFCraftTool：独立的 PdfCraft 指南站',
  description:
    'PDFCraftTool.org 介绍如何下载和安装 PdfCraft、它与 Adobe Acrobat 的对比，以及实际使用体验。联系邮箱 support@pdfcrafttool.org。',
  updated_at: '2026-10-15',
};

## 我们做什么

PDFCraftTool 是一个关于 **PdfCraft** 的独立网站。PdfCraft 是 ArtCraft 团队开发的免费开源 PDF 编辑器。我们帮助你顺利用上 PdfCraft，并判断它能否替代付费的 PDF 订阅。在本站你可以找到：

- **PdfCraft 下载**：Windows、macOS、Linux、FreeBSD 和网页版，始终链接到 github.com/storytold/pdfcraft 的发布文件；
- **安装指南**：覆盖所有平台，包括如何用 SHA-256 校验值核验下载文件；
- **使用教程**：阅读、搜索、整理页面、合并与拆分文件、表单、密码和命令行等日常操作；
- **与 Adobe Acrobat 的功能对比**：价格、平台、隐私，以及 PdfCraft 目前还做不到的事；
- **实际使用体验**：在真实文档上使用 PdfCraft 的心得，以及托管的 PdfCraft 在线版，方便你直接在浏览器中试用。

## 我们的做法

每次 PdfCraft 发布新版本，我们都会安装试用，并随软件变化更新指南。我们介绍的功能，要么亲自用过，要么有 PdfCraft 项目文档可查。Acrobat 的价格与功能来自 adobe.com，并在对比页标注日期。我们会像介绍优点一样清楚地指出 PdfCraft 的不足，因为客观的对比比推销更有用。

## 独立性

PDFCraftTool **不是** PdfCraft 官方网站，与 ArtCraft 及 Adobe Inc. 均无关联。我们不对 PdfCraft 收费，也不重新打包或修改它，所有下载都指向 ArtCraft 在 GitHub 上的发布页。本站与 GitHub 上的 PDFCraftTool/pdfcraft 浏览器工具集也没有关系，那是另一支团队的另一个项目。官方项目请访问 [getartcraft.com/apps/pdfcraft](https://getartcraft.com/apps/pdfcraft) 或 [PdfCraft GitHub 仓库](https://github.com/storytold/pdfcraft)。

## 联系我们

发现指南过时、链接失效或 Acrobat 对比中有错误？安装 PdfCraft 时遇到问题？请发送邮件至 [support@pdfcrafttool.org](mailto:support@pdfcrafttool.org)。我们会阅读每一封邮件，通常在两个工作日内回复。

关于 PdfCraft 软件本身的错误报告和功能建议，建议提交到官方 [PdfCraft 问题追踪](https://github.com/storytold/pdfcraft/issues) 或 [ArtCraft Discord](https://discord.gg/artcraft)，开发者可以直接处理。
